import React, { Component } from 'react'
import { Route, withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Header from './components/Header'
import SelfOnboardFormContainer from './SukiSelfOnboard'
import Success from './Success'
import ErrorPage from './Error'
import { BREAKPOINT, ONBOARD_TYPE } from './constants'

import GcpSelfOnboardContainer from './GcpSelfOnboard'

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  z-index: 1;
  background: #2E5F62;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: auto;
  padding-top: 100px;

  @media (max-width: ${BREAKPOINT.SMALL}) {
    padding-top: 50px;
  }
`

class SelfOnboardContainer extends Component {
  state = {
    isScrolledDown: false
  }

  handleScroll = (e) => {
    const scrollPos = e.target.scrollTop
    const oldIsScrolledDown = this.state.isScrolledDown
    const isScrolling = scrollPos > 0

    if (oldIsScrolledDown !== isScrolling) {
      this.setState({ isScrolledDown: isScrolling })
    }
  }

  render () {
    const { isScrolledDown } = this.state
    return (
      <Container id='element_within_div' onScroll={this.handleScroll}>
        <Header isScrolledDown={isScrolledDown} isWhite />

        {/* GCP onboarding */}
        <Route
          exact
          path='/gcp-register'
          render={() => <GcpSelfOnboardContainer />}
        />

        <Route
          exact
          path='/register'
          render={() => <SelfOnboardFormContainer isScrolledDown={isScrolledDown} />}
        />

        <Route
          exact
          path='/demo'
          render={() => <SelfOnboardFormContainer isScrolledDown={isScrolledDown} />}
        />

        <Route
          exact
          path='/gcp-register/success'
          render={() => <Success type={ONBOARD_TYPE.GCP} />}
        />
        <Route
          exact
          path='/register/success'
          render={() => <Success type={ONBOARD_TYPE.SUKI} />}
        />

        <Route
          exact
          path='/gcp-register/error'
          render={() => <ErrorPage />}
        />

        <Route
          exact
          path='/register/error'
          render={() => <ErrorPage />}
        />
      </Container>
    )
  }
}

export default withRouter(SelfOnboardContainer)
